<template>
    <transition name="router-anim">
      <div class="kits">
        <div class="kits-title">
          <div class="title id">
            KIT ID
          </div>
          <div class="title status">
            STATUS
          </div>
          <div class="title first-name">
            FIRST NAME
          </div>
          <div class="title last-name">
            LAST NAME
          </div>
          <div class="title email">
            EMAIL
          </div>
          <div class="title phone">
            PHONE
          </div>
           <div class="title result" >
            REPORT RESULT
          </div>
          <div class="title date">
            ACTIVATED DATE
          </div>
        </div>
        <div class="kits-item" v-for="(item, index) in analytics" :key="index">
          <div
            class="kit-desc id"
            @click.stop="stopPropagation"
            @click="showModal(item.id, item.user_id, 'kit')"
            >
            {{ convertKitId(item.kit_id) }}
          </div>
           <div
            class="kit-desc status"
            :style="
              item.status === 'on_hold' ? { color: 'rgb(232, 122, 1)' } : null
            "
          >
            <span class="onHoldStatus" v-if="item.status === 'on_hold'">
              On Hold
              <button
                class="onhold-btn"
              >
                <img
                  class="onhold-btn-img"
                  src="../../../images/dashboard/onhold.png"
                  alt="#"
                />
              </button>
            </span>
            <span v-if="item.status === 'analysis_completed'"
              >Analysis Complete</span
            >
            <span v-if="item.status === 'analysis_failed'">Analysis Failed</span>
            <span v-if="item.status === 'lab_received'">Lab Received</span>
            <span v-if="item.status === 'lab_awaiting'">Submitted</span>
            <span v-if="item.status === 'shipped'">Shipped</span>
            <span v-if="item.status === 'activated'">Activated</span>
            <span v-if="item.status === 'delivered'">Delivered</span>
            <div
              class="status-line"
              :style="
                item.status === 'on_hold'
                  ? { backgroundColor: 'rgba(232, 122, 1, .4)' }
                  : null
              "
            >
              <div
                class="status-line-bg"
                :style="[
                  item.status === 'shipped' ? { width: '16.6%' } : null,
                  item.status === 'delivered' ? { width: '28.8%' } : null,
                  item.status === 'activated' ? { width: '49.8%' } : null,
                  item.status === 'lab_awaiting' ? { width: '66.4%' } : null,
                  item.status === 'lab_received' ? { width: '83%' } : null,
                  item.status === 'on_hold'
                    ? { width: '83%', backgroundColor: '#E87A01' }
                    : null,
                  item.status === 'analysis_failed'
                    ? { width: '100%', backgroundColor: 'red' }
                    : null,
                  item.status === 'analysis_completed' ? { width: '100%' } : null
                ]"
              ></div>
            </div>
          </div>
          <div class="kit-desc first-name">
            <span>{{ item.collected_first_name }}</span>
          </div>
          <div class="kit-desc last-name">
            <span>{{ item.collected_last_name }}</span>
          </div>
          <div class="kit-desc email" v-if="item.collected_email">
            <span>{{ item.collected_email }}</span>
          </div>
          <div class="kit-desc email" v-else>
            <span v-if="item.user">{{ item.user.email }}</span>
          </div>
          <div class="kit-desc phone">
            <span v-if="item.user">{{ makePhone(item.user.phone) }}</span>
          </div>
          <div class="kit-desc result">
            <div v-if="item.status === 'analysis_completed'">
              <span
                class="status green"
                v-if="
                  item.result === 0"
                >Not Evident</span
              >
              <span
                class="status yellow"
                v-if="
                item.result === 1"
                >Slightly Evident</span
              >
              <span
                class="status orange"
                v-if="item.result === 2"
                >Moderately Evident</span
              >
              <span
                class="status red"
                v-if=" item.result === 3"
                >Significantly Evident</span
              >
            </div>
            <div v-else >
              <span>N/A</span>
            </div>
          </div>
          <div class="kit-desc date">
            {{ date(item.activated_at) }}
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import moment from "moment";
  import { mapGetters , mapActions} from "vuex";
  import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";
  import Paginate from "vuejs-paginate";
  
  export default {
    name: "customerKit",
    props: ['userkits'],
    mixins: [parseAndConvertKitId],
    data() {
      return {
        analytics: null
      };
    },
      components: {
      Paginate
    },
    methods: {
        ...mapActions([
          "testKitInfo",
          "getUserInfo",
        ]),
        changePage(item) {
          this.setAdminPginationPage(item).then(() => {
            this.getAnalyticsInfoList(this.params);
          });
        },
        date(localDate) {
            if (localDate !== null) {
              let date = new Date(localDate);
              return moment(date).format("MM/DD/YYYY");
            }
        },
        makePhone(phone) {
          // Check if phone is null or undefined
          if (phone === null || phone === undefined) {
            return null;
          }

          // Remove any non-digit characters from the input
          const cleanPhone = cleanPhone.replace(/\D/g, '');

        
          // Check if the cleaned phone number is exactly 10 digits
          if (cleanPhone.length === 11 || cleanPhone.length === 10) {
            const phoneArr = cleanPhone.split("");
            let  convertedPhone = null;
            if (cleanPhone.length === 11){
            convertedPhone = `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${phoneArr[5]}${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${phoneArr[10]}`;
            } else if (cleanPhone.length === 10) {
            convertedPhone = `(${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${phoneArr[3]}${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}`;
            }
            return convertedPhone;
          } else {
            return null;
          }
        },
       showModal(kitId, userId, modal) {
        this.testKitInfo(kitId).then(res => {
          if (modal === "kit") {
            if (userId !== null) {
              this.getUserInfo(userId).then(res => {
                this.$emit("showModal", true);
              });
            } else {
              this.$emit("showModal", true);
            }
          } else if (modal === "hold") {
            this.$emit("showComment", {
              txt: this.$store.getters.getTestKitInfo.reason_on_hold,
              show: true,
              id: this.$store.getters.getTestKitInfo.id
            });
          }
        });
      },
        openAnalytics(first_name, last_name, email, id) {
          this.$emit("showAnalyticsInfo", {
            first_name,
            last_name,
            id,
            email,
            show: true
          });
        },
        date(localDate) {
          if (localDate !== null) {
            let date = new Date(localDate);
            return moment(date).format("MM/DD/YYYY");
          }
        },
        stopPropagation(event) {
          event.stopPropagation();
        }
      },
      mounted() {
        this.analytics = this.userkits;
    }
  };
  </script>
  <style scoped lang="scss">
  .kits {
    margin: 30px 0 0 0;
  }
  .kits-title {
    display: flex;
    justify-content: space-between;
    margin: 0 0 20px 0;
    padding: 0 30px;
  }
  .title {
    color: #b3b3b3;
    font-size: 12px;
    font-family: TTNormsMedium, sans-serif;
  }
  .kit-desc.id {
    min-width: 130px;
    width: 100%;
    max-width: 130px;
    cursor: pointer;
    transition: all 0.5s linear;
  }
  .kit-desc.id:hover {
    color: #005eb8;
    font-family: TTNormsRegular, sans-serif;
  }
  .title.status {
    min-width: 170px;
    width: 100%;
    max-width: 170px;
  }
  .kit-desc.status {
    min-width: 170px;
    width: 100%;
    max-width: 170px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .kit-desc.status span {
    width: 100%;
    max-width: 170px;
    overflow: hidden;
  }
  .title.id {
    min-width: 130px;
    width: 100%;
    max-width: 130px;
  }
  .title.first-name {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.first-name {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .title.last-name {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.last-name {
     min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .title.email {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.email {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
    overflow: hidden;
    padding: 0 5px 0 0;
  }
  .kit-desc.email span {
    width: 100%;
    max-width: 150px;
    overflow: hidden;
    display: inline-block;
  }
  span{
    color: #58595b;
  }
  .kit-desc.first-name span,
  .kit-desc.last-name span {
    width: 100%;
    max-width: 140px;
    overflow: hidden;
    display: inline-block;
  }
  .title.phone {
    min-width: 130px;
    width: 100%;
    max-width: 130px;
  }
  .kit-desc.phone {
    min-width: 130px;
    width: 100%;
    max-width: 130px;
  }
  .title.result {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .kit-desc.result {
    min-width: 150px;
    width: 100%;
    max-width: 150px;
  }
  .title.result img {
    max-width: 7px;
    height: 14px;
  margin-left: 17px;
  }
  .title.result .down {
    transform: rotate(180deg);
  }
  .title.date {
    min-width: 150px;
    width: 100%;
    position: relative;
    cursor: pointer;
  }
  .title.date img {
    max-width: 7px;
    height: 14px;
    position: absolute;
    top: -3px;
    right: 25px;
  }
  .title.date .down {
    transform: rotate(180deg);
  }
  .kit-desc.date {
    min-width: 150px;
    width: 100%;
  }
  .kits-item {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    padding: 25px 30px;
    background-color: #fff;
    margin: 10px 0;
    border-radius: 5px;
  }
  .kits-item:hover {
    background-color: #e0e9f4;
  }
  .kits-item:hover .remove-kit-btn {
    display: block;
  }
  .kit-desc {
    color: #58595b;
    font-size: 12px;
    font-family: TTNormsLight, sans-serif;
  }
  .status-line {
    width: 100%;
    max-width: 140px;
    height: 3px;
    background-color: rgba(0, 70, 173, 0.3);
    margin: 5px 0 0 0;
    position: relative;
  }
  .status-line-bg {
    position: absolute;
    width: 50%;
    content: "";
    left: 0;
    top: 0;
    height: 100%;
    background-color: #005eb8;
  }
  .status {
    color: #cccdcf;
  }
  .status.green {
    color: green;
  }
  .status.red {
    color: red;
  }
  .status.orange {
    color: orange;
  }
  .status.purple {
    color: #ac75bd;
  }
  .status.yellow {
    color: gold;
  }
  .pogination {
    margin: 20px 0 0 0;
  }
  .status-line {
    width: 100%;
    max-width: 140px;
    height: 3px;
    background-color: rgba(0, 70, 173, 0.3);
    margin: 5px 0 0 0;
    position: relative;
  }
  .status-line-bg {
    position: absolute;
    width: 50%;
    content: "";
    left: 0;
    top: 0;
    height: 100%;
    background-color: #005eb8;
  }
  .remove-icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    padding: 0;
  }
  .onhold-btn {
    background-color: transparent;
    border: none;
    padding: 0;
    max-width: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    margin: 0 0 0 5px;
    cursor: pointer;
  }
  .onhold-btn-img {
    max-width: 100%;
  }
  .onHoldStatus {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .remove-kit-btn {
    display: none;
    position: absolute;
    width: 20px;
    height: 20px;
    border: 1px solid #58595b;
    border-radius: 5px;
    right: 20px;
    cursor: pointer;
    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      height: 1px;
      width: 13px;
      background-color: #58595b;
      top: 50%;
      left: 50%;
      transform: translate(-50%) rotate(45deg);
    }
    &:after {
      transform: translate(-50%) rotate(-45deg);
    }
    &:hover {
      border-color: red;
      &:before,
      &:after {
        background-color: red;
      }
    }
  }
  @media print {
    .kits {
      display: none;
    }
  }
  </style>
  